import { Link } from "react-router-dom";

/** Placeholder for links whose feature isn't built yet (guides, help, shop). */
export function ComingSoon({ title, blurb }: { title: string; blurb: string }) {
  return (
    <section className="coming-soon">
      <div className="eyebrow">Coming soon</div>
      <h1>{title}</h1>
      <p className="muted">{blurb}</p>
      <Link to="/devices">← Back to your devices</Link>
    </section>
  );
}
